// extracted by mini-css-extract-plugin
export var boxItems = "_aw-1";
export var boxItemsLg = "_aw-2";
export var button = "_aw-7";
export var buttonHoverless = "_aw-9";
export var buttonLg = "_aw-8";
export var filterGroupBox = "_aw-0";
export var icon = "_aw-3";
export var iconSecondary = "_aw-6";
export var iconWrapper = "_aw-4";
export var iconWrapperLg = "_aw-5";
export var truncatedLabel = "_aw-a";